import {
	BigNum,
	BN,
	FUNDING_RATE_BUFFER_PRECISION,
	FUNDING_RATE_PRECISION_EXP,
	PRICE_PRECISION,
	PRICE_PRECISION_EXP,
} from '@velocity-exchange/sdk';
import { UISerializableFundingRateRecord } from '@velocity-exchange/common';
import { SimpleFundingRateRecord } from '../@types/types';

export const getFundingRate = (rate: BN, oracleTwap: BN): number => {
	return (
		BigNum.from(
			rate.mul(PRICE_PRECISION.mul(new BN(100))).div(oracleTwap),
			PRICE_PRECISION_EXP
		).toNum() / FUNDING_RATE_BUFFER_PRECISION.toNumber()
	);
};

export const getSimpleFundingRateRecord = (
	record: UISerializableFundingRateRecord
): SimpleFundingRateRecord => {
	const isAsymmetric = !record.fundingRateLong.eq(record.fundingRateShort);

	return {
		marketIndex: record.marketIndex,
		ts: record.ts.toNumber() * 1000,
		fundingRate: getFundingRate(
			record.fundingRate.val,
			record.oraclePriceTwap.val
		),
		marketPrice: record.markPriceTwap.toNum(),
		isAsymmetric,
		fundingRateLong: getFundingRate(
			record.fundingRateLong.val,
			record.oraclePriceTwap.val
		),
		fundingRateShort: getFundingRate(
			record.fundingRateShort.val,
			record.oraclePriceTwap.val
		),
	};
};

/**
 * To get funding rate as a percentage, you need to multiply by the funding rate buffer precision
 * @param rawFundingRate
 * @returns
 */
export const getFundingRatePct = (rawFundingRate: BN) => {
	return BigNum.from(
		rawFundingRate.mul(FUNDING_RATE_BUFFER_PRECISION),
		FUNDING_RATE_PRECISION_EXP
	);
};
